/** Dashboard role tabs (mirrors DashboardPage roleModules keys, excluding guest). */
export const DASHBOARD_ROLE_MODULE_KEYS = [
  'coordinator',
  'training_manager',
  'supervisor',
  'instructor',
  'attendee',
  'tacticore',
  'k9_ops',
] as const;

export function countAvailableDashboardRoles(userRoles: string[]): number {
  return DASHBOARD_ROLE_MODULE_KEYS.filter((key) => userRoles.includes(key))
    .length;
}

export function hasMultipleDashboardRoles(userRoles: string[]): boolean {
  return countAvailableDashboardRoles(userRoles) > 1;
}

/** True when DashboardPage renders the role-switcher anchor (single-role users hide it). */
export function isRoleSwitcherTourTargetVisible(root: ParentNode = document): boolean {
  return (
    root.querySelector('[data-tour-stable="role-switcher"]') !== null ||
    root.querySelector('[data-tour="role-switcher"]') !== null
  );
}

export function shouldSkipRoleSwitcherTourStep(root: ParentNode = document): boolean {
  return !isRoleSwitcherTourTargetVisible(root);
}
